import { render } from "./TransactionDetail.vue?vue&type=template&id=eb60f248&scoped=true"
import script from "./TransactionDetail.vue?vue&type=script&lang=ts"
export * from "./TransactionDetail.vue?vue&type=script&lang=ts"

import "./TransactionDetail.vue?vue&type=style&index=0&id=eb60f248&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-eb60f248"

export default script